/**
 * The storefronts (sites) the CRM knows about, keyed by their locale, with the country name and flag
 * used to present them. Shared by the top-bar locale filter ({@link LocaleSwitcherService}) and the
 * lake-level market fee editor, which labels one row per site.
 *
 * This is presentation only. Anything that identifies a site in data uses its id — the locale is how a
 * row is labelled, never how it is keyed.
 */
export interface SiteLocale {
  code: string;
  country: string;
  flag: string;
}

/** The five markets, in the order the sites were created (NED, DUI, UK, IT, FR). */
export const SITE_LOCALES: readonly SiteLocale[] = [
  { code: 'nl', country: 'Netherlands', flag: 'icons/flags/nl.svg' },
  { code: 'de', country: 'Germany', flag: 'icons/flags/de.svg' },
  { code: 'en', country: 'United Kingdom', flag: 'icons/flags/gb.svg' },
  { code: 'it', country: 'Italy', flag: 'icons/flags/it.svg' },
  { code: 'fr', country: 'France', flag: 'icons/flags/fr.svg' },
];

/**
 * The entry for a locale, or null for one this list does not know about — a site added to the database
 * after the fact. Callers fall back rather than inventing a country name or, worse, a wrong flag.
 */
export function siteLocale(code: string): SiteLocale | null {
  return SITE_LOCALES.find((l) => l.code === code) ?? null;
}
